<template>
  <div id="modal-informacao">
    <button
      v-if="buttonTemplate === 'default'"
      type="button"
      :class="{ 'has-badge': enableBadge }"
      :data-badge="badgeValue"
      @click="openModalInformacao"
    >
      <i class="icofont-question"></i>
    </button>
    <b-modal
      v-model="modalShow"
      hide-footer
      centered
      scrollable
      ref="modal"
      id="modal-informacao-body"
    >
      <template #modal-header>
        <div class="d-flex justify-content-between w-100">
          <div class="modal-informacao-accessibility">
            <!-- <ul>
              <li>
                <a
                  href=""
                  title="Aumentar fonte"
                  v-on:click.prevent.stop="aumentarFonte()"
                  >A+</a
                >
              </li>
              <li>
                <a
                  href=""
                  title="Diminuir fonte"
                  v-on:click.prevent.stop="diminuirFonte()"
                  >A-</a
                >
              </li>
            </ul> -->
          </div>

          <span @click="modalShow = false">
            <i class="icofont-close" style="cursor: pointer"></i>
          </span>
        </div>
      </template>
      <div
        v-if="isIframe == false"
        id="modal-informacao-body"
        v-html="text"
      ></div>
      <div v-if="isIframe == true" id="modal-informacao-body">
        <div id="loader-iframe" v-if="loadingIframe">
          <b-spinner
            large
            style="width: 3rem; height: 3rem"
            variant="primary"
          ></b-spinner>
        </div>
        <iframe
          :src="urlIframe"
          frameborder="0"
          :width="iframeWidth"
          :height="iframeHeight"
          @load="finishLoadingIframe"
        ></iframe>
      </div>
      <!-- Checkbox para controle -->
      <!-- <div class="modal-footer">
        <label>
          <input
            type="checkbox"
            v-model="doNotShowAgain"
            @change="updateModalPreference"
          />
          Não mostrar novamente
        </label>
      </div> -->
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ModalInformacao',
  components: {},
  props: {
    text: {
      type: String,
    },
    isIframe: {
      type: Boolean,
      default: false,
    },
    urlIframe: {
      type: String,
      default: '',
    },
    pageIdentifier: {
      type: String,
      default: '',
    },
    buttonTemplate: {
      type: String,
      default: 'default',
    },
    iframeWidth: {
      type: String,
      default: '100%',
    },
    iframeHeight: {
      type: String,
      default: '1024px',
    },
    enableBadge: {
      type: Boolean,
      default: false,
    },
    badgeValue: {
      type: [String, Number],
      default: 1,
    },
    keyAjuda: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      modalShow: false,
      loadingIframe: false,
      doNotShowAgain: false,
    }
  },
  mounted() {
    /**
     * Se for para exibir o iframe então abre o loading do iframe
     */
    if (this.isIframe) {
      this.startLoadingIframe()
      this.checkModalPreference()
      // Chama a função showModal para garantir que o modal seja exibido inicialmente
      // this.showModal()
    }
  },
  methods: {
    showModal() {
      if (!this.doNotShowAgain) {
        this.modalShow = true
      }
    },

    getPreferences() {
      const preferences =
        JSON.parse(sessionStorage.getItem('modalPreferences')) || []
      return preferences
    },

    savePreferences(preferences) {
      sessionStorage.setItem('modalPreferences', JSON.stringify(preferences))
    },

    checkModalPreference() {
      const preferences = this.getPreferences()
      const pagePreference = preferences.find(
        (pref) => pref.pageIdentifier === this.pageIdentifier
      )

      if (pagePreference) {
        const now = new Date()
        const expirationDate = new Date(pagePreference.expirationDate)
        if (now > expirationDate) {
          // Expiração atingida, remove a preferência
          const updatedPreferences = preferences.filter(
            (pref) => pref.pageIdentifier !== this.pageIdentifier
          )
          this.savePreferences(updatedPreferences)
          this.doNotShowAgain = false
        } else {
          this.doNotShowAgain = pagePreference.doNotShowAgain
        }
      }
    },

    updateModalPreference() {
      const preferences = this.getPreferences()
      const now = new Date()
      const expirationDate = new Date()
      expirationDate.setDate(now.getDate() + 30)

      const pagePreferenceIndex = preferences.findIndex(
        (pref) => pref.pageIdentifier === this.pageIdentifier
      )

      if (this.doNotShowAgain) {
        const newPreference = {
          pageIdentifier: this.pageIdentifier,
          doNotShowAgain: true,
          expirationDate: expirationDate.toISOString(),
        }

        if (pagePreferenceIndex !== -1) {
          preferences[pagePreferenceIndex] = newPreference
        } else {
          preferences.push(newPreference)
        }
      } else if (pagePreferenceIndex !== -1) {
        preferences.splice(pagePreferenceIndex, 1) // Remove a preferência se o checkbox foi desmarcado
      }

      this.savePreferences(preferences)
    },

    startLoadingIframe() {
      this.loadingIframe = true
    },

    finishLoadingIframe() {
      this.loadingIframe = false
    },

    aumentarFonte() {
      let elements = document
        .querySelector('#modal-informacao-body')
        .querySelectorAll('*')
      let fonts = []

      function getFontSize() {
        for (let i = 0; i < elements.length; i++) {
          let fontSize = window
            .getComputedStyle(elements[i], null)
            .getPropertyValue('font-size')
          fonts.push(parseFloat(fontSize))
        }
      }

      getFontSize()

      for (let i = 0; i < elements.length; i++) {
        ++fonts[i]
        elements[i].style.fontSize = fonts[i] + 'px'
      }
    },

    diminuirFonte() {
      let elements = document
        .querySelector('#modal-informacao-body')
        .querySelectorAll('*')
      let fonts = []

      function getFontSize() {
        for (let i = 0; i < elements.length; i++) {
          let fontSize = window
            .getComputedStyle(elements[i], null)
            .getPropertyValue('font-size')
          fonts.push(parseFloat(fontSize))
        }
      }

      getFontSize()

      for (let i = 0; i < elements.length; i++) {
        --fonts[i]
        elements[i].style.fontSize = fonts[i] + 'px'
      }
    },

    /**
     * Esconde o badge do modal informação
     */
    hideBadgeModalInformacao() {
      this.$store.commit('setPermissaoRawItem', {
        key: this.keyAjuda,
        value: 0,
      })
    },

    async openModalInformacao() {
      this.modalShow = true

      if (!this.enableBadge) {
        return
      }

      try {
        const response = await this.$api.put(
          `/app/permissoes/${this.$store.state.cod_ibge}/${this.$store.state.id_funcao}/ajuda/${this.keyAjuda}`
        )

        if (response.data && response.data.error === false) {
          this.hideBadgeModalInformacao()
        }
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>

<style lang="scss">
#loader-iframe {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#modal-informacao-body {
  .modal-dialog {
    max-width: 1350px;
  }
}

#modal-informacao button {
  width: 35px;
  height: 35px;
  border-radius: 32px;
  display: inline-block;
  background-color: #0fafd7;
  color: #fff;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  margin-top: 0;
  float: right;
}

#modal-informacao button {
  position: relative;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #0fafd7;
  color: #fff;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  border: none;
  cursor: pointer;

  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px rgba(0, 0, 0, 0.2),
    0 1px 5px rgba(0, 0, 0, 0.12);
}

/* Badge */
#modal-informacao button.has-badge::after {
  content: attr(data-badge);
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 20px;
  height: 20px;
  padding: 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ff3d00;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  border-radius: 999px;
  border: 2px solid #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}

.modal-informacao-accessibility ul {
  display: inline-flex;
  margin: 10px 0 !important;
  padding: 0;
  gap: 5px;
}

.modal-informacao-accessibility ul li {
  border: 1px solid;
  list-style-type: none;
  padding: 5px;
  width: 30px;
  text-align: center;
  background-color: #6c757d;
  border-color: #6c757d;
  border-radius: 3px;
}

.modal-informacao-accessibility ul li a {
  color: #fff;
  font-size: 14px;
}

.modal-informacao-accessibility ul li a:hover {
  color: #000;
}

#write {
  margin: 0 60px;
  height: auto;
  width: inherit;
  word-break: normal;
  overflow-wrap: break-word;
  position: relative;
  white-space: normal;
  overflow-x: visible;
  @media screen and (max-width: 656px) {
    margin: 0 15px;
  }
  ol,
  ul {
    position: relative;
    list-style-type: disc;
  }
  h1 {
    font-size: 2rem;
  }
  h2 {
    font-size: 1.8rem;
  }
  h3 {
    font-size: 1.6rem;
  }
  h4 {
    font-size: 1.4rem;
  }
  h5 {
    font-size: 1.2rem;
  }
  h6 {
    font-size: 1rem;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin-top: 1rem;
    margin-bottom: 1rem;
    white-space: pre-wrap;
  }
  a {
    cursor: pointer;
  }
  li div {
    padding-top: 0px;
  }
  blockquote {
    margin: 1rem 0px;
  }
  li p {
    margin: 0.5rem 0px;
  }
  li blockquote {
    margin: 1rem 0px;
  }
  li {
    margin: 0px;
    position: relative;
  }
  blockquote > :last-child {
    margin-bottom: 0px;
  }
  blockquote > :first-child,
  li > :first-child {
    margin-top: 0px;
  }
  ul:first-child,
  ol:first-child {
    margin-top: 30px;
  }
  a {
    color: #4183c4;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    position: relative;
    margin-top: 1rem;
    margin-bottom: 1rem;
    font-weight: bold;
    line-height: 1.4;
    cursor: text;
  }
  h1:hover a.anchor,
  h2:hover a.anchor,
  h3:hover a.anchor,
  h4:hover a.anchor,
  h5:hover a.anchor,
  h6:hover a.anchor {
    text-decoration: none;
  }
  h1 tt,
  h1 code {
    font-size: inherit;
  }
  h2 tt,
  h2 code {
    font-size: inherit;
  }
  h3 tt,
  h3 code {
    font-size: inherit;
  }
  h4 tt,
  h4 code {
    font-size: inherit;
  }
  h5 tt,
  h5 code {
    font-size: inherit;
  }
  h6 tt,
  h6 code {
    font-size: inherit;
  }
  h1 {
    font-size: 2.25em;
    line-height: 1.2;
    border-bottom: 1px solid #eee;
  }
  h2 {
    font-size: 1.75em;
    line-height: 1.225;
    border-bottom: 1px solid #eee;
  }
  h3 {
    font-size: 1.5em;
    line-height: 1.43;
  }
  h4 {
    font-size: 1.25em;
  }
  h5 {
    font-size: 1em;
  }
  h6 {
    font-size: 1em;
    color: #777;
  }
  p,
  blockquote,
  ul,
  ol,
  dl,
  table {
    margin: 0.8em 0;
  }
  li > ol,
  li > ul {
    margin: 0 0;
    list-style-type: square;
  }
  hr {
    height: 2px;
    padding: 0;
    margin: 16px 0;
    background-color: #e7e7e7;
    border: 0 none;
    overflow: hidden;
    box-sizing: content-box;
  }

  li p.first {
    display: inline-block;
  }
  ul,
  ol {
    padding-left: 30px;
  }
  ul:first-child,
  ol:first-child {
    margin-top: 0;
  }
  ul:last-child,
  ol:last-child {
    margin-bottom: 0;
  }
  blockquote {
    background: rgba(247, 126, 126, 0.2);
    border-left: 4px solid #dd2e2e;
    border-radius: 4px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12), 0 3px 10px rgba(0, 0, 0, 0.08);
    padding: 15px;
    color: #777777;
  }
  blockquote blockquote {
    padding-right: 0;
  }
  code {
    background-color: #f3f4f4;
    padding: 0 2px 0 2px;
    color: #000;
  }

  .md-fences,
  code,
  tt {
    border: 1px solid #e7eaed;
    background-color: #f8f8f8;
    border-radius: 3px;
    padding: 0;
    padding: 2px 4px 0px 4px;
    font-size: 0.9em;
  }
  code {
    text-align: left;
    vertical-align: initial;
  }
}
</style>
